module.exports = __webpack_public_path__ + "static/media/director-showall_inactive.ca5af81b.svg";